
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {translate, translateFilter} from "@/auxillary/translation";
import {resolveConstraintExpression} from "@/auxillary/constraint.expression.resolver";
import InstrumentContextCache from "@/models/instrument.context.cache";

@Component({
  name: 'InstrumentHints',
  components: {
    OkDialog
  },
  filters: {
    translateFilter
  }
})
export default class InstrumentHints extends Vue {

  @Prop({required: true})
  private instrument: Readonly<InstrumentContextCache>;
  private showHints = false;

/*@Watch('dataField', {immediate: true})
  onDataFieldChanged(dataField: DataFieldCache | undefined) {
    //this.hasAnyHints = (dataField?.hintRules && dataField?.hintRules?.length > 0) ?? false;
    //this.hasHiddenHints = this.hiddenHints.length > 0;
  }*/
  get hasVisibleHints() {
    return this.visibleHintRules.length > 0
  }

  public get visibleHintRules() {
    if (this.instrument?.hintRules && this.instrument?.hintRules.length > 0)
      return this.instrument?.hintRules?.filter(r =>  !r.isDeleted &&
          (!r.constraintExpression || resolveConstraintExpression(r.constraintExpression, undefined, undefined, this.instrument)));
    return [];
  }

  get hasHiddenHints() {
    return this.hiddenHints.length > 0;
  }

  get hints() {
    return this.visibleHintRules?.filter(r => !r.definition.hidden) ?? [];
  }

  get hiddenHints() {
    return this.visibleHintRules?.filter(r => r.definition.hidden) ?? [];
  }

  translateHint(displayKey: string) {
    return translate(displayKey)
  }

}
